import { authGuard } from './guards/auth.guard';
import { loginGuard } from './guards/login.guard';
import { Routes } from '@angular/router';
import { subscriptionGuard } from './guards/subscription.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login')
        .then((m) => m.LoginComponent),
    canActivate: [loginGuard],
  },
  {
    path: 'auth/plan',
    loadComponent: () =>
      import('./pages/auth/plan-selection/plan-selection.component')
        .then((m) => m.PlanSelectionComponent),
    canActivate: [loginGuard],
  },
  {
    path: 'auth/signup',
    loadComponent: () =>
      import('./pages/signup/signup')
        .then((m) => m.SignUpComponent),
    canActivate: [loginGuard],
  },
  {
    path: 'signup',
    redirectTo: '/auth/signup',
    pathMatch: 'full',
  },
  {
    path: 'auth/forgot-password',
    loadComponent: () =>
      import('./pages/forgot-password/forgot-password')
        .then((m) => m.ForgotPasswordComponent),
    canActivate: [loginGuard],
  },
  {
    path: 'auth/forgot-password/confirm',
    loadComponent: () =>
      import('./pages/forgot-password-confirm/forgot-password-confirm')
        .then((m) => m.ForgotPasswordConfirmComponent),
    canActivate: [loginGuard],
  },
  {
    path: 'subscription/payment',
    loadComponent: () =>
      import('./pages/subscription-payment/subscription-payment')
        .then((m) => m.SubscriptionPaymentComponent),
  },
  {
    path: 'billing/return',
    loadComponent: () =>
      import('./pages/billing-return/billing-return')
        .then((m) => m.BillingReturnComponent),
    canActivate: [authGuard],
  },
  {
    path: 'billing/checkout',
    loadComponent: () =>
      import('./pages/billing-checkout/billing-checkout')
        .then((m) => m.BillingCheckoutPageComponent),
    canActivate: [authGuard],
  },
  {
    path: 'billing/payment-result',
    loadComponent: () =>
      import('./pages/billing-payment-result/billing-payment-result')
        .then((m) => m.BillingPaymentResultComponent),
    canActivate: [authGuard],
  },
  {
    path: 'oauth/meta-callback',
    loadComponent: () =>
      import('./pages/oauth-meta-callback/oauth-meta-callback')
        .then((m) => m.OAuthMetaCallbackComponent),
    canActivate: [authGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('./components/layout/main-layout/main-layout')
        .then((m) => m.MainLayoutComponent),
    canActivate: [
      authGuard,
      subscriptionGuard
    ],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./components/dashboard/dashboard/dashboard')
            .then((m) => m.DashboardComponent),
      },
      {
        path: 'inbox',
        loadComponent: () =>
          import('./pages/inbox/inbox-page')
            .then((m) => m.InboxPageComponent),
      },
      {
        path: 'inbox/:inboxId',
        loadComponent: () =>
          import('./pages/inbox/inbox-page')
            .then((m) => m.InboxPageComponent),
      },
      {
        path: 'inbox/:inboxId/thread/:threadId',
        loadComponent: () =>
          import('./pages/inbox/inbox-page')
            .then((m) => m.InboxPageComponent),
      },
      {
        path: 'agenda',
        loadComponent: () =>
          import('./pages/agenda/agenda')
            .then((m) => m.AgendaComponent),
      },
      {
        path: 'leads',
        loadComponent: () =>
          import('./pages/leads/leads')
            .then((m) => m.LeadsComponent),
      },
      {
        path: 'leads/:id',
        loadComponent: () =>
          import('./pages/leads/components/lead-detail/lead-detail')
            .then((m) => m.LeadDetailComponent),
      },
      {
        path: 'pipeline',
        loadComponent: () =>
          import('./pages/pipeline/pipeline')
            .then((m) => m.PipelineComponent),
      },
      {
        path: 'proposals',
        loadComponent: () =>
          import('./pages/proposals/proposals')
            .then((m) => m.ProposalsComponent),
      },
      {
        path: 'settings/pipelines',
        loadComponent: () =>
          import('./pages/pipelines/pipelines')
            .then((m) => m.PipelinesComponent),
      },
      {
        path: 'contacts',
        loadComponent: () =>
          import('./pages/contacts/contacts')
            .then((m) => m.ContactsComponent),
      },
      {
        path: 'companies',
        loadComponent: () =>
          import('./pages/companies/companies')
            .then((m) => m.CompaniesComponent),
      },
      {
        path: 'activities',
        loadComponent: () =>
          import('./pages/activities/activities')
            .then((m) => m.ActivitiesComponent),
      },
      {
        path: 'products',
        loadComponent: () =>
          import('./pages/products/products')
            .then((m) => m.ProductsComponent),
      },
      {
        path: 'tools/automations',
        loadComponent: () =>
          import('./pages/automations/automations')
            .then((m) => m.AutomationsComponent),
      },
      {
        path: 'integrations',
        loadComponent: () =>
          import('./pages/integrations/integrations')
            .then((m) => m.IntegrationsComponent),
      },
      {
        path: 'apps-integrations',
        loadComponent: () =>
          import('./pages/integrations/integrations')
            .then((m) => m.IntegrationsComponent),
      },
      {
        path: 'proposal-templates',
        loadComponent: () =>
          import('./pages/proposal-templates/proposal-templates')
            .then((m) => m.ProposalTemplatesComponent),
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./pages/reports/reports.page')
            .then((m) => m.ReportsPageComponent),
      },
      {
        path: 'settings/users',
        loadComponent: () =>
          import('./pages/users/users')
            .then((m) => m.UsersComponent),
      },
      {
        path: 'settings/custom-fields',
        loadComponent: () =>
          import('./pages/custom-fields/custom-fields')
            .then((m) => m.CustomFieldsComponent),
      },
      {
        path: 'settings/lost-reasons',
        loadComponent: () =>
          import('./pages/lost-reasons/lost-reasons')
            .then((m) => m.LostReasonsComponent),
      },
      {
        path: 'settings/brands',
        loadComponent: () =>
          import('./pages/marcas/marcas')
            .then((m) => m.MarcasComponent),
      },
      {
        path: 'settings/channels',
        loadComponent: () =>
          import('./pages/commercial/channels/channels-page')
            .then((m) => m.ChannelsPageComponent),
      },
      {
        path: 'commercial/channels',
        loadComponent: () =>
          import('./pages/commercial/channels/channels-page')
            .then((m) => m.ChannelsPageComponent),
      },
      {
        path: 'commercial/channels/linkedin/:channelAccountId',
        loadComponent: () =>
          import('./pages/commercial/channels/manage-linkedin/manage-linkedin-page')
            .then((m) => m.ManageLinkedinPageComponent),
      },
      {
        path: 'marketing/tags',
        loadComponent: () =>
          import('./pages/marketing/tags/marketing-tags-page')
            .then((m) => m.MarketingTagsPageComponent),
      },
      {
        path: 'marketing/segments',
        loadComponent: () =>
          import('./pages/marketing/segmentos/marketing-segmentos-page')
            .then((m) => m.MarketingSegmentosPageComponent),
      },
      {
        path: 'marketing/segments/new',
        loadComponent: () =>
          import('./pages/marketing/segmentos/marketing-segmento-editor-page')
            .then((m) => m.MarketingSegmentoEditorPageComponent),
      },
      {
        path: 'marketing/segments/:id',
        loadComponent: () =>
          import('./pages/marketing/segmentos/marketing-segmento-editor-page')
            .then((m) => m.MarketingSegmentoEditorPageComponent),
      },
      {
        path: 'marketing/templates',
        loadComponent: () =>
          import('./pages/marketing/templates/marketing-templates-page')
            .then((m) => m.MarketingTemplatesPageComponent),
      },
      {
        path: 'marketing/templates/new',
        loadComponent: () =>
          import('./pages/marketing/templates/marketing-template-editor-page')
            .then((m) => m.MarketingTemplateEditorPageComponent),
      },
      {
        path: 'marketing/templates/:id',
        loadComponent: () =>
          import('./pages/marketing/templates/marketing-template-editor-page')
            .then((m) => m.MarketingTemplateEditorPageComponent),
      },
      {
        path: 'marketing/campaigns',
        loadComponent: () =>
          import('./pages/marketing/campanhas/marketing-campanhas-page')
            .then((m) => m.MarketingCampanhasPageComponent),
      },
      {
        path: 'marketing/campaigns/new',
        loadComponent: () =>
          import('./pages/marketing/campanhas/marketing-campanha-wizard-page')
            .then((m) => m.MarketingCampanhaWizardPageComponent),
      },
      {
        path: 'marketing/campaigns/:id',
        loadComponent: () =>
          import('./pages/marketing/campanhas/marketing-campanha-detail-page')
            .then((m) => m.MarketingCampanhaDetailPageComponent),
      },
      {
        path: 'settings/channels/:channelId',
        loadComponent: () =>
          import('./pages/canais/canal-config/canal-config')
            .then((m) => m.CanalConfigComponent),
      },
      {
        path: 'settings/roles',
        loadComponent: () =>
          import('./pages/roles/roles')
            .then((m) => m.RolesComponent),
      },
      {
        path: 'settings/preferences',
        loadComponent: () =>
          import('./pages/preferences/preferences')
            .then((m) => m.PreferencesComponent),
      },
      {
        path: 'settings/subscriptions',
        loadComponent: () =>
          import('./pages/subscription/subscription.page')
            .then((m) => m.SubscriptionPageComponent),
      },
      {
        path: 'subscription',
        redirectTo: '/settings/subscriptions',
        pathMatch: 'full',
      },
      {
        path: 'settings/billing',
        loadComponent: () =>
          import('./pages/billing/billing')
            .then((m) => m.BillingPageComponent),
      },
      {
        path: 'settings/current-subscription',
        loadComponent: () =>
          import('./pages/subscription-vigente/subscription-vigente')
            .then((m) => m.SubscriptionVigenteComponent),
      },
      {
        path: 'my-profile',
        loadComponent: () =>
          import('./pages/my-profile/my-profile').then(
            (m) => m.MyProfileComponent
          ),
      },
    ],
  },
];
